window.addEventListener("load", (event) => {
  const mediaSlider = document.querySelector(".media-carousel")
  let currentIndex
  if (mediaSlider) {
    let minContent = true
    let contentAlign = "center"
    let mediaCards = $(".media-experts").children()

    if (mediaCards.length <= 3) contentAlign = "left"

    if (mediaCards.length <= 3 && $(window).width() >= 992) {
      minContent = false
      $(mediaCards).each(function () {
        $(this).addClass("extended-card")
        updateHeight()
      })
    } else {
      $(mediaCards[0]).css("top", "100px")
    }

    if ($(window).width() <= 576) {
      $(".carousel-cell").css("top", "50px")
      minContent = true
    }

    function updateHeight() {
      let baseHeight = $(".media-experts__card:not(.is-selected)").height()
      let cellHeight = $(".media-experts__card.is-selected").height()

      cellHeight > baseHeight
        ? $(".media-experts .flickity-viewport").height(cellHeight + 70)
        : $(".media-experts .flickity-viewport").height(cellHeight + 30)

      if ($(window).width() <= 576) {
        cellHeight > baseHeight
          ? $(".media-experts .flickity-viewport").height(cellHeight + 60)
          : $(".media-experts .flickity-viewport").height(cellHeight + 30)
      } else if ($(window).width() <= 768) {
        cellHeight > baseHeight
          ? $(".media-experts .flickity-viewport").height(cellHeight + 60)
          : $(".media-experts .flickity-viewport").height(cellHeight + 30)
      } else if ($(window).width() < 901) {
        cellHeight > baseHeight
          ? $(".media-experts .flickity-viewport").height(cellHeight + 60)
          : $(".media-experts .flickity-viewport").height(cellHeight + 30)
      } else if ($(window).width() <= 980) {
        cellHeight > baseHeight
          ? $(".media-experts .flickity-viewport").height(cellHeight + 60)
          : $(".media-experts .flickity-viewport").height(cellHeight + 30)
      } else if ($(window).width() <= 1225) {
        cellHeight > baseHeight
          ? $(".media-experts .flickity-viewport").height(cellHeight + 160)
          : $(".media-experts .flickity-viewport").height(cellHeight + 100)
      } else if ($(window).width() > 1225) {
        cellHeight > baseHeight
          ? $(".media-experts .flickity-viewport").height(cellHeight + 160)
          : $(".media-experts .flickity-viewport").height(cellHeight + 80)
      }
    }

    function animateCards(index) {
      let lastSlide = mediaCards.length
      let fadeSlide = index - 2
      let nextSlide = index + 1
      let prevSlide = index - 1
      currentIndex = index

      if (prevSlide == -1) {
        prevSlide = mediaCards.length - 1
      }
      if (nextSlide == mediaCards.length) {
        nextSlide = 0
      }
      if (nextSlide >= mediaCards.length) {
        nextSlide = 1
      }
      if (fadeSlide == -1) {
        fadeSlide = lastSlide - 1
      }
      if ($(window).width() >= 992) {
        $(mediaCards[index]).animate({
          top: "100px",
          opacity: 1,
        })
        $(mediaCards[prevSlide]).animate({
          top: "0",
          opacity: 1,
        })
        $(mediaCards[fadeSlide]).animate({
          top: "100px",
          opacity: 0,
        })
        $(mediaCards[nextSlide]).animate({
          opacity: 1,
          top: "0",
        })
        updateHeight()
      }
    }

    let flkty = new Flickity(".media-experts", {
      //autoPlay: ' true',
      // contain: true,
      groupCells: 1,
      adaptiveHeight: false,
      resize: true,
      draggable: minContent,
      // creates and enables buttons to click to previous & next cells
      pageDots: true,
      prevNextButtons: minContent,
      // create and enable page dots
      // resize: true,
      wrapAround: minContent,
      cellAlign: contentAlign,

      arrowShape:
        "M0.095,0.73 h0.809 l-0.231,-0.332 c-0.017,-0.024,-0.017,-0.063,0,-0.088 c0.017,-0.024,0.044,-0.024,0.061,0 l0.303,0.435 c0.001,0.001,0.002,0.002,0.003,0.003 c0.01,0.014,0.013,0.034,0.012,0.052 c0,0.003,-0.001,0.006,-0.001,0.009 c-0.002,0.008,-0.004,0.015,-0.008,0.021 c-0.001,0.002,-0.001,0.005,-0.002,0.007 c-0.001,0.001,-0.002,0.002,-0.003,0.003 l-0.303,0.435 c-0.017,0.024,-0.044,0.024,-0.061,0 c-0.017,-0.024,-0.017,-0.063,0,-0.088 l0.231,-0.332 H0.095 c-0.024,0,-0.043,-0.028,-0.043,-0.062 S0.071,0.73,0.095,0.73",
      on: {
        change: function (index) {
          animateCards(index)
          updateHeight()
        },
        load: function (index) {
          animateCards(index)
          updateHeight()
        },
        ready: function (index) {
          if (mediaCards.length <= 3 && $(window).width() >= 992) {
            $(mediaCards).each(function () {
              $(this).removeClass("is-selected")
            })
            $(mediaCards[1])
              .animate({
                top: "100px",
                opacity: 1,
              })
              .addClass("is-selected")
          }
          animateCards(index)
          updateHeight()
        },
      },
    })

    // $(".media-carousel .next").on("click", function () {
    //     // let analyticsIndex = currentIndex + 1;
    //     // track('Key Media', 'Next Clicked', {
    //     //     key_media: {
    //     //         url: 'https://example.org'
    //     //     }
    //     // }, this);
    //     // track('Key Media', 'Media ' + analyticsIndex + ' Shown Manual', {
    //     //     key_media: {
    //     //         url: 'https://example.org'
    //     //     }
    //     // }, this);
    // });
    // $(".media-carousel .previous").on("click", function () {
    //     // let analyticsIndex = currentIndex + 1;
    //     // track('Key Media', 'Previous Clicked', {
    //     //     key_media: {
    //     //         url: 'https://example.org'
    //     //     }
    //     // }, this);
    //     // track('Key Media', 'Media ' + analyticsIndex + ' Shown Manual', {
    //     //     key_media: {
    //     //         url: 'https://example.org'
    //     //     }
    //     // }, this);
    // });
    if ($(window).width() >= 576) {
      $(".media-carousel .flickity-prev-next-button")
        .mouseover(function () {
          $(this).find("svg").addClass("flickity-button-clicked")
        })
        .mouseout(function () {
          $(".flickity-button-clicked").removeClass("flickity-button-clicked")
        })
    }

    let mediaDuration = 4
    let mediaInterval = 10
    let mediaIsPaused = false
    let mediaSliderWrapper = document.querySelector(".media-carousel")
    mediaSliderWrapper.addEventListener("mouseenter", function () {
      mediaIsPaused = true
    })

    mediaSliderWrapper.addEventListener("mousemove", function () {
      mediaIsPaused = true
    })

    mediaSliderWrapper.addEventListener("mouseleave", function () {
      mediaIsPaused = false
    })

    if ($(window).width() <= 576) {
      let prevBtn = document.querySelector(".media-carousel .flickity-prev-next-button.previous")
      let nextBtn = document.querySelector(".media-carousel .flickity-prev-next-button.next")
      prevBtn.addEventListener("touchend", function () {
        setTimeout(() => {
          mediaIsPaused = false
          $(this).toggleClass("gray")
          $(this).find("svg").removeClass("flickity-button-clicked")
        }, 1500)
      })
      nextBtn.addEventListener("touchend", function () {
        setTimeout(() => {
          mediaIsPaused = false
          $(this).toggleClass("gray")
          $(this).find("svg").removeClass("flickity-button-clicked")
        }, 1500)
      })
    }

    let mediaPercentTime, mediaStep, mediaTick

    function mediaReviewsAnalytics(elmnt, type) {
      let mediaURL = ""
      let targetElm, currentIndex
      let shown = type

      if (elmnt) {
        currentIndex = elmnt.index()
        targetElm = $(".media-experts .carousel-cell").eq(currentIndex)
        mediaURL = targetElm.find("a").attr("href")
      } else {
        targetElm = $(".media-experts .carousel-cell").closest(".is-selected")
        mediaURL = targetElm.find("a").attr("href")
        currentIndex = targetElm.index()
      }

      track(
        "Homepage",
        "Media Review " + (currentIndex + 1) + " Displayed",
        {
          displayMethod: shown == "manual" ? "Manual" : "Auto"
        },
        targetElm
      )
    }

    function startProgressbar() {
      resetProgressbar()
      mediaPercentTime = 0
      mediaIsPaused = false //false
      mediaTick = window.setInterval(increase, mediaInterval)
    }

    function increase() {
      if (!mediaIsPaused) {
        mediaStep = (mediaDuration * 1000) / mediaInterval
        mediaPercentTime += 100 / mediaStep

        //progressBar.style.width = percentTime + "%";
        $(".media-carousel .dot span").css("width", "0%")
        $(".media-carousel .dot.is-selected span").css("width", mediaPercentTime + "%")
        //$('.dot.is-selected').css("width", percentTime + '%');
        if (mediaCards.length > 3) {
          if (mediaPercentTime >= 100) {
            flkty.next()
            startProgressbar()

            mediaReviewsAnalytics(false, "auto")
          }
        }
      }
    }

    function resetProgressbar() {
      $(".media-carousel .dot.is-selected span").css("width", "0%")
      clearTimeout(mediaTick)
    }

    startProgressbar()
    // Moving dots
    $(".media-carousel .flickity-page-dots .dot").each(function () {
      $(this).append("<span></span>")
    })

    $(".media-carousel .flickity-page-dots .dot").on("click", function () {
      let elmnt = $(this)
      mediaReviewsAnalytics(elmnt, "manual")
    })

    flkty.on("dragEnd", function (event, pointer) {
      mediaReviewsAnalytics(false, "manual")
    })
  }
})
